var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { Button, HStack, Text } from "@chakra-ui/react";
export const VideoSchema = yup.object({
    id: yup.number().nullable().default(null),
    type: yup.string().notRequired().default(undefined),
    subtype: yup.string().notRequired().default(undefined)
});
export const PimcoreVideo = (props) => {
    const [id, setId] = useState("video" + Math.floor(Math.random() * 1000));
    const [editable, setEditable] = useState(null);
    const [ref, setRef] = useState(null);
    const [showNative, setShowNative] = useState(false);
    const [path, setPath] = useState(null);
    /**
     * Need to decouple our callback from the mutation observer itself.
     * Otherwise, all components this calls back to will work with stale state
     * which is a hassle to avoid
     */
    const mutationCallback = useCallback(() => {
        if (editable) {
            props.onChange(editable.getValue());
        }
    }, [editable, props.onChange, editable]);
    const mutationCallbackRef = useRef(mutationCallback);
    mutationCallbackRef.current = mutationCallback;
    useEffect(() => {
        if (!ref) {
            return;
        }
        // @ts-ignore
        let editable = new pimcore.document.editables.relation("pimcore_video_" + id, id, [], props.data);
        editable.setRealName("reactvideo");
        editable.setInDialogBox(true);
        editable.render();
        setEditable(editable);
    }, [ref]);
    useEffect(() => {
        if (ref === null || editable === null) {
            return;
        }
        // @ts-ignore
        const observer = new MutationObserver(() => mutationCallbackRef.current());
        observer.observe(ref, { attributes: true, childList: true, subtree: true });
        return () => {
            observer.disconnect();
        };
    }, [ref, editable]);
    useEffect(() => {
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!props.data.id) {
                return;
            }
            const response = yield fetch("/api/asset/" + props.data.id);
            const assetInfo = yield response.json();
            setPath("Asset: " + assetInfo.name);
        });
        load();
    }, [props.data]);
    return (React.createElement(React.Fragment, null,
        showNative && React.createElement("div", { style: { width: "500px", height: "50px" }, id: "pimcore_video_" + id, ref: setRef }),
        !showNative &&
            React.createElement(HStack, null,
                React.createElement(Text, { fontSize: "sm" }, path ? path : "No Asset selected"),
                React.createElement(Button, { onClick: () => setShowNative(true) }, "Edit"))));
};
